import config from '../../config';

import { Shot, HlReelShot } from '../../types';

import { getAccessTokenClient, getAttendeeClient } from '../client/http';

const {
  apiBaseUrl: { elements: baseUrl },
} = config;

const accessTokenClient = () => getAccessTokenClient(baseUrl);
const attendeeClient = () => getAttendeeClient(baseUrl);

export const getTemplateFile = async (eventId: string, isPublic?: boolean) => {
  try {
    const response = await (
      isPublic ? attendeeClient : accessTokenClient
    )().get(
      `api/files?eventId=${eventId}&fileType=video&fileKind=VideoTemplate`,
    );
    return response.data.files.slice(-1)[0];
  } catch (err: any) {
    throw new Error(`Error getting template file: ${err.message}`);
  }
};

export const getTemplateData = async (eventId: string, isPublic?: boolean) => {
  try {
    const response = await (
      isPublic ? attendeeClient : accessTokenClient
    )().get(`api/video-template/current?eventId=${eventId}`);

    let hlReel = response.data.videoTemplate;

    let requiredShots: Shot[] = [];
    hlReel?.shots.forEach((shot: HlReelShot) => {
      if (shot.type === 'placeholder')
        requiredShots.push({
          shotIndex: shot.shotIndex,
          duration: shot.segment.durationMilliseconds / 1000,
        });
    });

    return {
      hasTemplate: true,
      hlReel,
      requiredShots,
    };
  } catch (err: any) {
    if (err.response?.status === 404) {
      return {
        hasTemplate: false,
        hlReel: null,
        requiredShots: [],
      };
    } else throw new Error(`Error getting a template: ${err.message}`);
  }
};
